import React, { useState } from 'react'
import { useFetchList } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from '../HistoryDialog.module.sass'
import { ProcessChangesHistory } from 'models'
import ClinicalStateHistory from './ClinicalStateHistory'
import InjuredStateHistory from './InjuredStateHistory'
import SegmentedControl from '@jimmyboys/liita-ui/dist/components/SegmentedControl'

const renderSelectedTab = (selectedTab, processHistory, state) => {
	switch (selectedTab) {
		case 'clinical':
			return <ClinicalStateHistory data={{ processHistory, state }} />
		default:
			return <InjuredStateHistory data={{ processHistory, state }} />
	}
}

const StateHistoryDialog = (props) => {
	const { data } = props
	const { processId } = data

	const { i18n } = useGlobal()

	const {
		contents: [processHistory = []],
		state,
	} = useFetchList(
		[`/clinical_processes/${processId}/history`],
		[ProcessChangesHistory.fromJSON]
	)

	const tabs = [
		{
			id: 'clinical',
			text: i18n`Clinical`,
		},
		{
			id: 'injured',
			text: i18n`Accident`,
		},
	]

	const [selectedTab, setSelectedTab] = useState(tabs[0].id)

	return (
		<VStack
			className={`${styles['history-root']} ${styles['--coordinator-history']}`}
		>
			<SegmentedControl
				className={styles['history-segment-control']}
				selectedTab={selectedTab}
				onSelect={(e) => {
					setSelectedTab(e.id)
				}}
				selectorType={'border'}
				tabs={tabs}
			/>
			{renderSelectedTab(selectedTab, processHistory, state)}
		</VStack>
	)
}

export default StateHistoryDialog
